import React, { useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import { Grid, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import tempEpisode1VideoBg from '../../assets/episode2Trailer.jpg';
import tempEpisode1VideoBgM from '../../assets/episode2VideoBgM.jpg';
import closeIcon from '../../assets/closeIcon.svg';
import playIcon from '../../assets/playButton.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      backgroundColor: theme.palette.common.background
    }
  },
  videoCont: {
    width: '85%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  buttonCont: {
    position: 'absolute',
    bottom: '3.5rem',
    left: '50%',
    marginLeft: '-8.5rem'
  },
  playTrailerButton: {
    color: '#fff',
    width: '17rem',
    border: '1px solid #fff',
    fontFamily: 'neuePlakB',
    fontSize: '.875rem',
    letterSpacing: '3px',
    borderRadius: 0,
    padding: '1rem',
    backgroundColor: theme.palette.common.ghostButton
  },
  videoModalCont: {
    width: '100%',
    height: '100vh',
    zIndex: 11,
    position: 'fixed',
    display: 'none',
    right: 0,
    top: 0,
    backgroundColor: '#000'
  },
  closeButtonCont: {
    position: 'absolute',
    top: '4rem',
    right: '2rem',
    width: '6rem',
    height: '6rem',
    [theme.breakpoints.down('md')]: {
      right: '2rem'
    },
    [theme.breakpoints.down('sm')]: {
      right: '1rem',
      top: '4rem'
    }
  },
  videoCont: {
    width: '100%',
    height: '100%'
  },
  video: {
    width: '85%'
  }
}));

const Episode2Video = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const [isOpen, setOpen] = useState(false);
  const { ref, inView } = useInView({ threshold: 0.05 });

  const toggleModal = () => {
    const drawer = document.getElementById('episode2Modal');
    if (!isOpen) {
      drawer.style.display = 'block';
      setOpen(true);
    } else {
      drawer.style.display = 'none';
      setOpen(false);
    }
  };

  return (
    <Grid container justifyContent="center" id="alabamaVideo" className={classes.wrapper}>
      <Grid ref={ref} id="episode2Modal" container className={classes.videoModalCont}>
        <Grid item className={classes.closeButtonCont}>
          <Button
            onClick={() => toggleModal()}
            className={classes.closeButton}
            style={{ width: '100%' }}
          >
            <img src={closeIcon} alt="x" style={{ width: '100%' }} />
          </Button>
        </Grid>
        {inView ? (
          <Grid container justifyContent="center" alignItems="center" className={classes.videoCont}>
            <Grid container justifyContent="center" alignItems="center" className={classes.video}>
              <Grid item style={{ width: '100%' }}>
                <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
                  <iframe
                    src="https://player.vimeo.com/video/652973750?h=f53ff659ce&amp;badge=0&amp;autopause=0&amp;autoplay=1&amp;player_id=0&amp;app_id=58479"
                    frameBorder="0"
                    allow="autoplay"
                    allowFullScreen
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%'
                    }}
                    title="Birmingham - Gilead - Blind Angels Episode 1"
                  ></iframe>
                </div>
              </Grid>
            </Grid>
          </Grid>
        ) : undefined}
      </Grid>
      <Grid container className={classes.videoCont}>
        <Grid item style={{ width: '100%' }}>
          <img
            src={matchesSM ? tempEpisode1VideoBgM : tempEpisode1VideoBg}
            alt="person"
            style={{ width: '100%' }}
          />
        </Grid>
        <Grid item className={classes.buttonCont} onClick={() => toggleModal()}>
          <Button className={classes.playTrailerButton}>
            <img src={playIcon} alt="play triangle icon" style={{ marginRight: '1rem' }} />
            PLAY EPISODE 2
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Episode2Video;
